import cadastroProdutos from './videos/cadastroProdutos.mp4'
import cadastroClientes from './videos/cadastroClientes.mp4'
import adicionarImagens from './videos/adicionarImagens.mp4'
import criarPedido from './videos/criarPedido.mp4'
import criarNFE from './videos/criarNFE.mp4'
import criarDevolucao from './videos/criarDevolucao.mp4'

import { Explication } from './styles'

export const articles = [
  {
    title: 'Como Cadastrar Um Produto?',
    description: 'Passo a passo para cadastrar um produto.',
    explication: () => (
      <Explication>
        <p>
          Preencha as informações mais comuns de um produto, para deixá-lo ainda
          mais completo. <strong>Seleção de Fotos</strong>,{' '}
          <strong>Composição de Kit</strong> e{' '}
          <strong>Produtos Filhos NÃO</strong> estão disponíveis na tela de{' '}
          <strong>criação</strong>. Logo após finalizar o cadastro, você será
          redirecionado para a tela de edição do produto que acabou de ser
          criado, podendo fazer todas as alterações disponíveis!{' '}
        </p>
      </Explication>
    ),
    video: cadastroProdutos,
    iconName: 'BoxFill',
    category: 'products',
  },
  {
    title: 'Como Cadastrar Um Cliente?',
    description: 'Passo a passo para cadastrar um cliente.',
    explication: () => (
      <Explication>
        <p>
          Cadastre um cliente de maneira rápida e eficaz, escolha o tipo de
          cliente, usando os checkboxs disponíveis no lado direito da tela, se
          for uma empresa, é possível digitar o CNPJ e o sistema busca
          automaticamente as informações encontradas.{' '}
          <strong>Razão Social</strong> e <strong>CNPJ (ou CPF)</strong> são{' '}
          <strong>obrigatórios</strong>!
        </p>
      </Explication>
    ),
    video: cadastroClientes,
    iconName: 'PersonCircle',
    category: 'customers',
  },
  {
    title: 'Como Adicionar Imagens ao Produto?',
    description:
      'Passo a passo para adicionar imagens ao produto e escolher uma como padrão.',
    explication: () => (
      <Explication>
        <p>
          Para adicionar imagens á um produto, você deve listar os produtos
          disponíveis, e <strong>editá-lo</strong>. Na tela de edição, clique no
          botão <strong>Imagens</strong>, <strong>Adicionar Imagem</strong>,
          após selecionar a imagem, é necessário salva-lá, então clique em{' '}
          <strong>Cadastrar Imagem(s)</strong>. Adicione quantas imagens quiser,
          para colocar uma imagem como padrão, clique no botão azul
          <strong> Colocar como imagem padrão</strong>, e pronto, essa imagem
          será setada como imagem de capa do seu produto!
        </p>
      </Explication>
    ),
    video: adicionarImagens,
    iconName: 'Image',
    category: 'products',
  },
  {
    title: 'Como Criar um Pedido?',
    description: 'Passo a passo para criar um pedido.',
    explication: () => (
      <Explication>
        <p>
          Criar pedidos é bem simples, você preenche as informações mais
          importantes, como <strong>cliente</strong>, <strong>conta</strong>,{' '}
          <strong>tipo de pedido</strong>, seleciona os produtos, colocando
          quantidade e preço, feito isso, será gerado a quantidade total do
          produto (quantidade * preço). Embaixo dos produtos, contém o total do
          pedido, somando o total de cada produto. Também é possível gerar
          parcelas do pedido, preenchendo o campo{' '}
          <strong>Dias para as parcelas</strong>, colocando valores separados
          por vírgula. A partir dos valores que você digitou, será acrescentado
          os dias, <strong>incluindo o dia do pedido</strong>, por exemplo,
          suponhamos que a data do pedido seja <strong>20/04/2024</strong>, e
          você digita o seguinte: <strong>5,10</strong>, a parcela 1{' '}
          <strong>(5 dias a partir da data do pedido)</strong> será{' '}
          <strong>24/04/2024</strong> e não <strong>25/04/2024</strong>. Ao
          preencher esse campo, o valor total do pedido será dividido igualmente
          entre cada parcela criada, sendo possível assim{' '}
          <strong>Lançar Contas</strong>, mas, atenção, você deve primeiro
          salvar o pedido clicando no botão <strong>Salvar Dados</strong> no
          canto inferior da tela.
        </p>
      </Explication>
    ),
    video: criarPedido,
    iconName: 'MailboxFlag',
    category: 'orders',
  },
  {
    title: 'Como Criar uma Nota Fiscal?',
    description: 'Passo a passo para criar uma nota fiscal.',
    explication: () => (
      <Explication>
        <p>
          Preencha os campos mais comuns de uma nota fiscal como os dados do{' '}
          <strong>destinatário</strong>, os <strong>itens da nota</strong> e o
          <strong> frete</strong>. Também é possível dividir o valor da nota
          entre parcelas, usando vírgula entre os dias inseridos,{' '}
          <strong>
            lembrando que já começa a contar a partir da data de emissão.{' '}
          </strong>
        </p>
      </Explication>
    ),
    video: criarNFE,
    iconName: 'FiletypeXml',
    category: 'nfes',
  },
  {
    title: 'Como Devolver Produtos de um Pedido?',
    description: 'Passo a passo para devolver um produto de um pedido.',
    explication: () => (
      <Explication>
        <p>
          É possível devolver qualquer produto de um pedido, basta clicar em{' '}
          <strong>Menu</strong> e clicar em <strong>Trocas e Devoluções</strong>
          . Ao entrar nessa tela, basta clicar em{' '}
          <strong>Adicionar Devolução</strong>, vai abrir um modal, onde você
          pode digitar o <strong>número do pedido</strong> e clicar no botão com
          a lupa para <strong>pesquisar</strong>. Ao pesquisar, vai aparecer um
          card com as informações do pedido, há um botão para{' '}
          <strong>ver os itens</strong>, e é onde todo o processo de devolução
          vai acontecer, há um checkbox ao lado de cada produto, onde só será
          habilitado quando{' '}
          <strong>for digitado a quantidade á ser devolvida</strong>, o checkbox
          só continuará habilitado{' '}
          <strong>
            enquanto a quantidade digitada for menor que a quantidade comprada
            do produto
          </strong>
          , depois que for digitado a quantidade, basta clicar no checkbox e
          selecionar o produto, após isso basta clicar em{' '}
          <strong>Confirmar</strong> para devolver os produtos. Todo o item que
          for devolvido, resultará em um <strong>saldo em haver</strong> para o
          comprador, podendo ser <strong>abatido</strong> na compra de novos
          produtos. Você também pode consultar esse saldo na tela{' '}
          <strong>Consultar Saldo.</strong>
        </p>
      </Explication>
    ),
    video: criarDevolucao,
    iconName: 'HandbagFill',
    category: 'products',
  },
]
